import React from 'react';
import { CloudSyncManager } from '../../components/CloudSyncManager/CloudSyncManager';

export default function CloudSyncPage() {
  return <CloudSyncManager />;
}
